import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createMobilePage = async (data) => {
  try {
    let res = await Api.post("/mobile-pages", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getMobilePage = async (query) => {
  try {
    let res = await Api.get("/mobile-pages", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getShips = async (query) => {
  try {
    let res = await Api.get("/menu-list", {
      params: query,
    });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getAllMobilePage = async (query) => {
  try {
    let res = await Api.get("/mobile-pages/all", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const exportMobilePage = async (query) => {
  try {
    let res = await Api.get("/mobile-pages/export", {
      responseType: "arraybuffer",
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deleteMobilePage = async (id) => {
  try {
    let res = await Api.delete("/mobile-pages/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateMobilePage = async (id, data) => {
  try {
    let res = await Api.patch("/mobile-pages/" + id, data);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};
export const updatePosition = async (banners, query) => {
  try {
    let res = await Api.patch("/mobile-pages/relocate-position", banners, {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
export const getMobilePageByID = async (query) => {
  try {
    let res = await Api.get("/mobile-pages/ids", {
      params: query,
    });
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Get" };
  }
};
export const updatePageComponents = async (data) => {
  try {
    let res = await Api.post("/page-components", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deletePageComponents = async (id) => {
  try {
    let res = await Api.delete("/page-components/" + id);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
